const REGISTER_STEP = 'REGISTER_STEP';
const CHANGE_STEP = 'CHANGE_STEP';
const CHANGE_EXEMPTION = 'CHANGE_EXEMPTION';

export default {
    REGISTER_STEP,
    CHANGE_STEP,
    CHANGE_EXEMPTION,
};
